import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-full-star",
  "use": "icon-full-star-usage",
  "viewBox": "0 0 36 33",
  "content": "<symbol viewBox=\"0 0 36 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-full-star\"><path d=\"M18 0l-4 12H0l11 8-5 13 12-8 12 8-5-13 11-8H22z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol